export default {
  SELECT_RETURN_ITEM: '选择退货商品',
  PLEASE_SELECT_A_RETURN_ITEM: '请选择退货商品',
  SELECT_ALL: '全选',
  SELECT_RETURN_REASON: '选择退货原因',
  SUBMIT_RETURN: '申请退货',
  PLEASE_SELECT_RETURN_ITEM: '请选择需要退货的商品',
  PLEASE_SELECT_RETURN_REASON: '请选择退货原因',
  RETURN_REASON: '退货原因',
  ADD_INSTRUCTIONS: '添加说明',
  QUESTION_DESCRIPTION: '问题描述',
  FILL_IN_DETAIL_DESCRIPTION: '请详细填写您的问题说明',
  REFUND_TO: '退款至',
  WECHAT_PAY: '微信支付',
  STARTING_REFUND_7_WORK_DAYS: '退货回到亚马逊海外库房1-7个工作日内开始退款',
  PICKUP_ADDRESS: '上门取货地址',
  ORIGINAL_ORDER_ADDRESS: '原订单收货地址',
  TOTAL_REFUND: '商品退款合计',
  RETURN_SHIPPING_FEE: '退货运费',
  DEDUCT_FROM_TOTAL_RETURN: '从退款总额中扣除',
  TOTAL_REFUND_AMOUNT: '退款总额',
  SUBMIT_RETURN_QUEST: '提交退货申请',
  ONLY_FOR: '仅限于',
  AVAILABLE_FOR_SUMBIT_RETURN: '前可申请退货',
  RETURN_SUBMISSION_RESULT: '申请退货结果',
  SUCCESSFULLY_SUBMITTED_RETURN: '退货申请提交成功',
  RETURN_FAILED: '退货失败',
  SUMBIT_DATE: '提交日期',
  DATE_FORMAT: 'YYYY年M月D日',
  PLEASE_FILL_NAME_ID_ADDRESS_YIKEMAN_WEBSITE:
    '亚⻢逊授权的国内物流承运商易客满将在48⼩时内短信通知您，去易客满官网填写姓名、身份证信息 (将用作商品退回亚马逊海外库房流程中清关使用) 及上门取货地址。',
  YIKEMAN_ASSIGN_YUANTONG_ARRANGE_PICKUP_TIME:
    '易客满收到您的清关信息后，将在48小时内委托圆通配送通过您提供的手机号联系您，安排上门取货的时间。',
  NO_PACKAGING_PROVIDED_DURING_PICK_UP:
    '配送上门取货前，不提供任何商品包装，请确保您的商品已经包装完好，以避免在运输过程中发生任何破损。',
  ESTIMATED_TOTAL_REFUND: '预估退款总额',
  REFUND_ARRIVED_ORIGINAL_ACCOUNT:
    '亚马逊海外库房在收到退回商品并确认其符合退货条款后为您安排退款，退款将在之后平均1-7个工作日后退到您的原支付账户。',
  VIEW_RETURN_DETAILS: '查看退货详情',
  AFTER_SALE: '退货/售后',
  AFTER_SALE_DETAIL: '售后详情',
  RETURN_DETAIL: '退货详情',
  APPLICATION_DATE: '申请日期',
  RETURN_ORDER_TIME: '退货申请时间',
  ORIGINAL_DELIVERY_ADDRESS: '原订单收货地址',
  REFUND_INSTRUCTIONS: '退款说明',
  REFUND_START_RETURNED_TO_AMAZON_OVERSEAS_WAREHOUSE:
    '退款于货物退回亚马逊海外库房后1-7个工作日内开始办理',
  NOT_SUPPORT_NO_REASON_REFUND: '不支持30天无理由退货',
  MY_ORDER: '我的订单',
  ORDER_DETAIL: '订单详情',
  ORDER_NUMBER: '订单号',
  ORDER_CREATION_TIME: '下单时间',
  ORDERER: '订购人',
  KYC_ERROR_ABOUT_TO_BE_CANCELLED: '订购人与支付人信息不一致，即将取消',
  KYC_ERROR_CANCELED: '订购人与支付人信息不一致，已取消',
  CANNOT_CANCEL_ORDER: '无法取消订单',
  CURREN_ORDER_CANNOT_BE_CANCELLED:
    '由于订单中部分商品已进入"订单处理中"或"准备出库"状态无法终止，且亚马逊海外购暂不支持部分订单取消，当前订单无法被取消。',
  IMPORT_FEE_INSTRUCTION: '进口费用说明',
  G_S_ESTIMATE_CHARGE_IMPORT_TAX_FEE:
    '亚马逊海外购会在您下单时依清关政策为您预估并收取相关进口税费',
  SHIPPING_FEE_INSTRUCTION: '运费说明',
  CONTINUE_APPLYING_FOR_RETURNS:
    '本单已为您节省¥{price}<br/>确认继续申请退货吗？',
  ACTUAL_SHIPPING_FEE_AFTER_YOU_PLACED_ORDER:
    '您在亚马逊海外购下单后，实际产生的物流配送费用',
  G_SITEMS_CANNOT_PROVIDE_INVOICE: '海外购商品无法提供发票',
  VIEW_LOGISTICS: '查看物流',
  CANCEL_ORDER: '取消订单',
  APPLY_RETURN: '申请退货',
  REPURCHASE: '再次购买',
  VIEW_HELP: '查看帮助',
  NO_PARTIAL_ORDER_CANCALLATION:
    '暂不支持部分订单取消，取消订单将取消全部订单。订单处理中和准备出库状态下商品已不能被取消。如需再次购买，以页面实时价格为准。',
  EVALUATE_ORDER: '去评价',
  SELECT_CANCEL_ASIN: '选择取消商品',
  CONFIRM_CANCEL_ALL: '确认取消全部',
  SELECT_CANCEL_REASON: '选择取消原因',
  PLEASE_SELECT_CANCEL_REASON: '请选择取消原因',
  CANCEL_FAILED: '取消失败',
  ADD_TO_CART_SUCCEED: '已加入购物车',
  ADD_TO_CART_FAILED: '加入购物车失败',
  LOGISTICS_INFORMATION: '物流信息',
  PARCEL: '包裹',
  TRACKING_PARCEL_NUMBER: '跟踪包裹号',
  ESTIMATED_ARRIVAL_TIME: '预计到达时间',
  PIECE: '件',
  ITEMS_TOTAL_PRICE: '商品总价',
  DISCOUNT: '促销优惠',
  IMPORT_FEE: '进口费用',
  SHIPPING_FEE: '运费',
  TOTAL_AMOUNT: '合计',
  NO_ORDER_INFORMATION: '暂无订单信息',
  NO_AS_ORDER_INFORMATION: '暂无售后信息',
  NO_REVIEW_INFORMATION: '暂无评价信息',
  NO_MORE: '没有更多了',
  TOTAL: '共',
  ESTIMATED: '预计',
  ARRIVED: '送达',
  AUTHENTICITY_GUARANTEE: '正品保证',
  CUSTOMER_SERVICE: '中文客服',
  USUALLY_TAKES: '海外直邮通常需要',
  A_FEW_DAYS_TO_ARRIVE: '4-12天送达',
  CANCEL_RETURN_REQUEST: '取消申请退货',
  CANCEL_RETURN_OR_NOT: '是否取消退货申请流程？',
  CONTINUE_RETURN: '继续退货',
  CANCEL_RETURN: '取消退货',
  CANCEL_REASONS: {
    ADD_REMOVE: '需要添加/减少商品',
    WRONG_PAYMENT_METHOD: '需要变更支付方式',
    WRONG_SHIPPING_ADDRESS: '需要变更配送地址',
    WITHOUT_EST_ARR_DATE_DATE_TOO_LATE: '未提供预计配送时间或预计配送时间太长',
    FOUND_CHEAPER: '在别处找到价格更低的商品',
    INCORRECT_INFO: '页面信息有误',
    NOT_FULL_FILLED: '长时间不发货',
    WRONG_ORDER: '错误下单',
    CHANGE_MIND: '改变主意，不想要了',
    PROMOTION_NOT_APPLIED: '没有享受促销优惠',
    OTHER: '其他'
  },
  ORDER_LIST_STATUS: {
    ALL: '全部订单',
    NOSHIPMENT: '待发货',
    DELIVERYING: '待收货',
    GOCOMMENT: '待评价',
    CANCEL: '已取消'
  },
  SHIPMENT_STATUS: {
    INTERNATIONAL: '国际运输中',
    UNDISPLAYED: '清关中',
    DOMESTIC: '国内运输中',
    DELIVERED: '配送成功'
  },
  FRONT_END_STATUS: {
    KYC_ERROR: '订购人与支付人信息不一致，已取消',
    WAITING_PAY: '订单已提交，未支付订单会被取消',
    CANCEL: '已取消',
    SHIPMENT_EMPTY: '订单已提交',
    WAITING_DELIVERY: '订单已提交',
    DELIVERYING: '已发货',
    DELIVERYED: '配送成功',
    DELIVERY_FAILED: '配送失败',

    CRETURNS_RETURNING: '退货申请已提交',
    CRETURNS_REFUND: '已退款',
    CRETURNS_UNDELIVERED_RETURNING: '包裹无法送达 退货中',
    CRETURNS_UNDELIVERED_REFUNDED: ' 包裹无法送达 已退款',
    RETURNING: '退货中',
    RETURNED: '已退款',
    WAITING_CONFIRMATION: '订单确认中'
  },
  REFUNDABLE: '可退款',
  CANCEL_ORDER_INSTRUCTION: '取消订单说明',
  CONTACT_CUSTOMER_SERVICE_TO_CANCEL_ORDER:
    '由于系统升级，请您联系客服申请订单取消。给您操作上带来的不便，我们深感抱歉。',
  APPLY_FOR_RETURN_REFUND_INSTRUCTION: '申请退货退款说明',
  CONTACT_CUSTOMER_SERVICE_FOR_RETURN_AND_REFUND:
    '由于系统原因，请您稍后重试或联系客服申请退货退款。给您操作上带来的不变，我们深感抱歉。',
  THE_ORDER_HAS_BEEN_SUCCESSFULLY_CANCELLED: '订单已成功取消',
  REFUND_WITHIN_7_WORK_DAYS: '退款平均1-7个工作日退回原支付方式',
  CUSTOMER_REVIEW: '评价中心',
  WAITING_FOR_REVIEW: '待评价',
  REVIEWED: '已评价/追评',
  GO_REVIEW: '去评价',
  FAILED_REVIEW_PLEASE_RE_EVALUATE: '评价未通过审核，请重新评价',
  PRODUCT_EVALUATION_REVIEW_IN_PROGRESS_PLEASE_WAITING:
    '个商品评价审核中， 需等待1-3个工作日，过审即生效',
  RULE: '规则',
  DELETE_REVIEW: '删除评价',
  CONFIRM_DELETE: '确定删除',
  CONFIRM_TO_DELETE_THIS_REVIEW:
    '您的评价可以影响更多买家的购买决策<br/>确定删除将永久移除该条评价',
  WRITE_A_REVIEW_FOR_THE_ASIN: '给宝贝写评价',
  WRITE_REVIEWS_AND_RECEIVE_BENEFITS: '写评价，入群领福利～～',
  DETAIL: '详情',
  WELCOME_TO_WRITE_DOWN_YOUR_USAGE_EXPERIENCE:
    '欢迎写下您的使用感受和喜好，10个字以上评价有效',
  CAMPAIGN_REWARD_RULES: '活动奖励规则',
  PLEASE_FILL_IN_THE_EVALUATION_CONTENT: '请填写评价内容',
  WORD_COUNT_CAN_BE_PUBLISHED: '超过10个字才能发布哦',
  REACH_THE_REVIEW_WORDS_LIMIT: '已到达200字输入上限',
  DELETE_SUCCESSFULLY: '删除成功',
  DELETE_FAILED: '删除失败',
  THE_REVIEW_HAS_BEEN_SUBMITTED: '评价已提交，过审后生效',
  CANCELLED_RETURN: '已取消退货',
  PAYMENT_METHOD: {
    WECHAT_PAY: '微信支付',
    CHINA_UNION_PAY: 'China Union Pay',
    CREDIT_CARD: '信用卡',
    GIFT_CARD: '礼品卡',
    CASH_ON_DELIVERY: '货到付款',
    EXTERNAL_PAYMENT: '外部支付',
    PAYMENT_PLATFORM: '支付平台',
    ALIPAY: '支付宝',
    HSBC_BANK: '汇丰银行卡',
    ELSE: '其它'
  },
  IN_CALCULATION: '计算中',
  CONTACT_CS_CONFIRM_RETURN: '联系客服确认退货',
  NOT_SUPPORT_REFUND: '不支持退货'
};
